/**
 * Global analytics tracking utility
 */

export type EventType = 'standard' | 'custom';

export interface TrackEventOptions {
  name: string;
  type?: EventType;
  properties?: Record<string, any>;
}

/**
 * Track an event with Meta Pixel
 */
export const trackMetaEvent = (name: string, type: EventType = 'standard', properties?: Record<string, any>) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    if (type === 'standard') {
      (window as any).fbq('track', name, properties);
    } else {
      (window as any).fbq('trackCustom', name, properties);
    }
    console.log(`[Analytics] Meta Pixel tracked ${type} event: ${name}`, properties);
  }
};

/**
 * Push an event to the GTM dataLayer
 */
export const trackGTMEvent = (event: string, properties?: Record<string, any>) => {
  if (typeof window !== 'undefined') {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({ event, ...properties });
    console.log(`[Analytics] GTM dataLayer event: ${event}`, properties);
  }
};

/**
 * Track an event with all configured analytics services
 */
export const trackEvent = ({ name, type = 'standard', properties }: TrackEventOptions) => {
  // Track with Meta Pixel
  trackMetaEvent(name, type, properties);

  // GA4, GTM, etc. can be added here
};

/**
 * Common standard events
 */
export const AnalyticsEvents = {
  PAGE_VIEW: 'PageView',
  VIEW_CONTENT: 'ViewContent',
  LEAD: 'Lead',
  PURCHASE: 'Purchase',
  CONTACT: 'Contact',
  SUBMIT_APPLICATION: 'SubmitApplication',
  COMPLETE_REGISTRATION: 'CompleteRegistration',
};
